module.exports = __webpack_public_path__ + "static/media/BMODE_50_10.fa5f1bce.jpg";